import React, { useState } from "react";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { TitleBar } from "../../Components/Common/TitleBar/titleBar";
import CountUp from "react-countup";
import { RealTimeMap } from "./RealTimeMap";
import { RealTimeList } from "./RealTimeList";
import { fetchTripDashboard } from "../../slices/thunks";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useRef } from "react";
import { getAllTripsRealTimeList, fetchTrackRealTimeTrip } from "../../slices/realTimeTripDetail/thunk";
import { filterDataByTripsAndAppendGeocodes } from "../../Components/Common/FilterData"
import "leaflet/dist/leaflet.css";

const DashboardAnalytics = () => {
  document.title = "Dashboard | D&A - Admin";
  const dispatch = useDispatch();
  const mapRef = useRef(null);
  const [polylineData, setPolylineData] = useState([]);
  const [focusedCoords, setFocusedCoords] = useState(null);
  const [selectedTrip, setSelectedTrip] = useState(null);


  const realTimeTripList = useSelector((state) => state.RealTimeTrip.tripList);
  const dashboard = useSelector((state) => state.TripDashboard);
  const loadingTrip = useSelector((state) => state.RealTimeTrip.loading);

  useEffect(() => {
    try {
      dispatch(getAllTripsRealTimeList());
    } catch (error) { }

    try {
      const interval = setInterval(() => {
        dispatch(getAllTripsRealTimeList());
      }, 60000);
      return () => clearInterval(interval);
    } catch (error) {

    }
  }, [dispatch]);

  const filteredTrips = realTimeTripList
    .filter((trip) => trip.driver && trip.driver.trim() !== "")
    .slice(0, 10);
  console.log("filteredTrips", loadingTrip);


  const dashboardCards = [
    {
      title: "Total Trip",
      count: parseFloat(dashboard.totalTrips) || 0,
      percent: parseFloat(dashboard.totalTripsInPerntage) || 0,
      trend: dashboard.trendInTotalTrips || "up",
    },
    {
      title: "Ongoing Trips",
      count: parseFloat(dashboard.ongoingTrips) || 0,
      percent: parseFloat(dashboard.ongoingTripsInPerntage) || 0,
      trend: dashboard.trendInOngoingTrips || "up",
    },
    {
      title: "Successful Trips",
      count: parseFloat(dashboard.successfulTrips) || 0,
      percent: parseFloat(dashboard.successfulTripsInPerntage) || 0,
      trend: dashboard.trendInSuccessfulTrips || "up",
    },
    {
      title: "Cancelled Trips",
      count: parseFloat(dashboard.cancelledTrips) || 0,
      percent: parseFloat(dashboard.cancelledTripsInPerntage) || 0,
      trend: dashboard.trendInCancelledTrips || "up",
    },
  ];

  const focusOnMarker = (tripId, lat, lng, zoom = 15) => {
    const latNum = Number(lat);
    const lngNum = Number(lng);

    if (mapRef.current && Number.isFinite(latNum) && Number.isFinite(lngNum)) {
      mapRef.current.panTo({ lat: latNum, lng: lngNum });
      mapRef.current.setZoom(zoom);
    } else {
      console.warn("Invalid lat/lng passed to focusOnMarker:", lat, lng);
    }
    setFocusedCoords({ lat, lng });
    setSelectedTrip(tripId);


  };

  const getTrackData = async (tripId, trip, zoom = 7) => {
    const endTime = Math.floor(Date.now() / 1000);
    const startTime = endTime - 24 * 60 * 60;

    try {
      const response = await dispatch(fetchTrackRealTimeTrip(startTime, endTime, trip, tripId));
      const filteredData = filterDataByTripsAndAppendGeocodes(response);

      const allPaths = filteredData.map((item) => {
        const pathCoords = (item.filtered_messages_with_geocodes || [])
          .filter(msg => msg.pos && isFinite(msg.pos.y) && isFinite(msg.pos.x))
          .map(msg => ({ lat: msg.pos.y, lng: msg.pos.x }));

        const color = item?.trip_metadata?.color || "#007BFF";

        return { path: pathCoords, color };
      });

      setPolylineData(allPaths);

      if (allPaths.length > 0 && allPaths[0].path.length > 0) {
        const firstPoint = allPaths[0].path[0];
        const lat = parseFloat(firstPoint.lat);
        const lng = parseFloat(firstPoint.lng);

        if (!isNaN(lat) && !isNaN(lng)) {
          setFocusedCoords({ lat, lng });
          mapRef.current.setZoom(zoom);
          setSelectedTrip(tripId);
        }
      }

    } catch (error) {
      console.error("Error fetching trip path data:", error);
    }
  };

  useEffect(() => {
    try {
      dispatch(fetchTripDashboard());
    } catch (error) { }
  }, [dispatch]);
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div className="d-flex flex-column gap-2 gap-sm-3">
            <TitleBar title="Dashboard" />

            <div className="dashbaord-card-container">
              {dashboardCards.map((element, index) => {
                return (
                  <Card key={index} className="card-animate dashboardCard mb-0">
                    <CardBody>
                      <div className="d-flex flex-column flex-sm-row justify-content-between">
                        <div>
                          <p className="mb-0 dashboardCardTitle">
                            {element.title}
                          </p>
                          <h2 className="mt-3 ff-secondary fw-semibold dashboardCardCount">
                            <span className="counter-value">
                              <CountUp
                                start={0}
                                end={element.count}
                                duration={4}
                              />
                            </span>
                          </h2>

                          {element.trend === "up" ? (
                            <p className="mb-0 d-flex flex-wrap align-items-center gap-1">
                              <span className="badge bg-light text-success">
                                <i className="ri-arrow-up-line align-middle"></i>{" "}
                                {element.percent} %
                              </span>
                              <span className="dashboardCardDescription">
                                vs. previous month
                              </span>
                            </p>
                          ) : (
                            <p className="mb-0 d-flex flex-wrap align-items-center gap-1">
                              <span className="badge bg-light text-danger">
                                <i className="ri-arrow-down-line align-middle"></i>{" "}
                                {element.percent} %
                              </span>
                              <span className="dashboardCardDescription">
                                vs. previous month
                              </span>
                            </p>
                          )}
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                );
              })}
            </div>
            <TitleBar title="Real time trip" />
            <div
              className="real-time-container"
              style={{ height: "auto", width: "100%" }}
            >
              <Row className="flex-column flex-xl-row h-100">
                <Col
                  xs={12}
                  xl={9}
                  className="order-1 order-xl-2 mb-3 mb-xl-0"
                  style={{
                    minHeight: 300,
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <RealTimeMap
                    data={filteredTrips}
                    mapRef={mapRef}
                    focusOnMarker={focusOnMarker}
                    getTrackData={getTrackData}
                    polylineData={polylineData}
                    focusedCoords={focusedCoords}
                    setTripId={setSelectedTrip}
                    tripId={selectedTrip}

                  />
                </Col>

                <Col
                  xs={12}
                  xl={3}
                  className="order-2 order-xl-1"
                  style={{
                    minHeight: 300,
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <RealTimeList
                    tripData={filteredTrips}
                    focusOnMarker={focusOnMarker}
                    loading={loadingTrip.tripList}
                    getTrackData={getTrackData}
                    setTripId={setSelectedTrip}
                    tripId={selectedTrip}
                    polylineData={polylineData}
                    setPolylineData={setPolylineData}
                  />
                </Col>
              </Row>
            </div>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default DashboardAnalytics;
